var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.device == 'desktop')?_c('Sidebar',{attrs:{"device":_vm.device,"user":_vm.user},on:{"logout":_vm.logout}}):_c('Navbar',{attrs:{"user":_vm.user,"device":_vm.device},on:{"logout":_vm.logout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }